<cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth">
  <span class="cap-table-wrapper-title" style="font-weight: bold">
    {{ "DominierteGrundstuecke" | translate }}
  </span>
  <ng-container class="cap-table-wrapper-content">
    <cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        <table class="cap-table-detail">
          <thead>
            <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
          </thead>
          <tbody>
            <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
          </tbody>
        </table>
      </div>
    </cap-list-loader>
    <ng-template #tableHeaders>
      <tr>
        <th style="width: 20%">{{ "Grundstueck" | translate }}</th>
        <th style="width: 20%">
          <span class="float-end pe-3">
            {{ "Anteil" | translate }}
          </span>
        </th>
        <th style="width: 60%">{{ "Rechtsgrund" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template #tableRows>
      @if (listLoader?.items) {
        @for (eigentumanteil of listLoader?.items | orderByGrundstuecknummer: true : "belastetesGrundstueck"; track eigentumanteil) {
          @if (eigentumanteil.object.belastetesGrundstueck) {
            @for (version of eigentumanteil.versionenVm; track version) {
              <tr>
                <td [capHistinfo]="version.object.histInfo">
                  <cap-kompakt-grundstueck [item]="eigentumanteil.object.belastetesGrundstueck" [navigateTo]="navigateTo">
                  </cap-kompakt-grundstueck>
                </td>
                <td>
                  <span [capHistinfo]="version.object.histInfo" class="float-end pe-3">
                    {{ version.quoteValue }}
                  </span>
                  <cap-kompakt-timepoint [item]="version.object.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
                </td>
                <td>
                  @for (rechtsgrund of eigentumanteil.object.rechtsgruende; track rechtsgrund) {
                    <div>
                      <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                    </div>
                  }
                </td>
              </tr>
            }
          }
        }
      }
    </ng-template>
  </ng-container>
</cap-beschreibung-table-wrapper>
